import { Trans } from "@lingui/react/macro";

import { Button } from "@/shared/ui/button";

import { FreshMatchesHint } from "../FreshMatchesHint";

type MatchListEmptyProps = {
  isRefreshing: boolean;
  onRefresh: () => void;
};

// Матчей нет и после ожидания истории.
export const MatchListEmpty = ({ isRefreshing, onRefresh }: MatchListEmptyProps) => (
  <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border p-6 text-center">
    <p className="font-semibold">
      <Trans>No matches yet</Trans>
    </p>
    <p className="text-sm text-muted">
      <Trans>
        Play a match in Deadlock and it shows up here. If you have just signed in, the history can
        take a bit longer to load.
      </Trans>
    </p>
    <FreshMatchesHint variant="empty" />
    <Button variant="outline" size="sm" loading={isRefreshing} onClick={onRefresh}>
      <Trans>Refresh</Trans>
    </Button>
  </div>
);
